/* ============
 * Event Bus
 * ============
 *
 * Note: mitt is very small (<200b) but doesn't support once(). Once once is needed (ba dum tss), we can migrate to dush:
 * https://github.com/tunnckoCoreLabs/dush
 */

import mitt from 'mitt';

const emitter = mitt();

export default emitter;
